export const STORE_RELATIONS_ALERT_DURATION = 4000
export const STORE_RELATIONS_SAVE_SUCCESS_MESSAGES = {
  CREATED: 'La relación fue creada exitosamente.',
  EDITED: 'La relación fue editada exitosamente.'
}
export const STORE_RELATIONS_LOADING_TEXT = 'Cargando...'
export const STORE_RELATIONS_NO_RESULTS_TEXT = 'No hay resultados'
export const STORE_RELATIONS_FALLBACK_TEXT = 'N/A'
export const STORE_RELATIONS_ERROR_PAGE_ALERT_MESSAGE_PREFIX =
  'Por favor verifique aquellas con estado '
export const STORE_RELATIONS_ERROR_PAGE_ALERT_STATUS = 'ERROR'
export const STORE_RELATIONS_ERROR_PAGE_ALERT_MESSAGE_SUFFIX =
  ' y haga las correcciones pertinentes.'

export const INITIAL_SECONDARY_USERS_VISIBLE = 2
export const STORE_RELATION_DEFAULT_STATUS = 'active'
export const STORE_RELATION_STATUS_VALUES = ['active', 'suspended', 'error', 'unassigned']

export const DEFAULT_FILTER_STATE = {
  mode: 'all',
  values: []
}

export const STORE_RELATIONS_UNASSIGNED_USER_FILTER_VALUE = '__WITHOUT_PRINCIPAL__'
export const STORE_RELATIONS_UNASSIGNED_USER_FILTER_LABEL = 'Relacion sin usuario principal'
export const STORE_RELATIONS_SECONDARY_USERS_TOGGLE_LABELS = {
  EXPAND: 'Ver más...',
  COLLAPSE: 'Ver menos'
}

export const STATUS_LABELS = {
  active: 'ACTIVO',
  suspended: 'SUSPENDIDO',
  error: 'ERROR'
}

export const STORE_RELATIONS_STATUS_UI_MAP = {
  active: {
    label: 'ACTIVO',
    className: 'oc-process-style'
  },
  suspended: {
    label: 'SUSPENDIDO',
    className: 'oc-open-style'
  },
  error: {
    label: 'ERROR',
    className: 'oc-error-style'
  }
}

export const DEFAULT_PRINCIPAL_CONFLICT_MESSAGE =
  'Hay multiples vendedores principales para esta configuracion. Debes.'

export const STORE_RELATIONS_ACTION_LABELS = {
  ASSIGN_USER: 'Asignar usuario',
  REASSIGN_USER: 'Reasignar usuario',
  EDIT: 'Editar',
  SUSPEND: 'Suspender',
  REACTIVATE: 'Reactivar'
}

export const STORE_RELATIONS_ASSIGN_USER_ACTION_LABEL = STORE_RELATIONS_ACTION_LABELS.ASSIGN_USER
export const STORE_RELATIONS_ASSIGN_USER_DETAILS_MESSAGE =
  'Falta asignar un vendedor a este cliente. Usa la accion'
export const STORE_RELATIONS_ASSIGN_USER_DETAILS_MESSAGE_SUFFIX = 'para continuar.'
export const STORE_RELATIONS_REASSIGN_USER_ACTION_LABEL =
  STORE_RELATIONS_ACTION_LABELS.REASSIGN_USER
export const STORE_RELATIONS_ASSIGN_USER_FLOW_MESSAGE =
  'Selecciona el usuario principal y guarda para completar esta relacion.'
export const STORE_RELATIONS_NO_PRINCIPAL_CANDIDATES_MESSAGE =
  'Esta relación presenta un error porque no tiene un cliente configurado. Por favor, contacta al equipo de soporte .'
export const STORE_RELATIONS_INACTIVE_CLIENT_MESSAGE =
  'El cliente esta inactivo. Las acciones de esta relacion estan deshabilitadas.'

export const STORE_RELATIONS_REASSIGN_MODAL_CURRENT_USER_LABELS = {
  CONFLICT: 'USUARIOS EN CONFLICTO',
  UNASSIGNED: 'SIN ASIGNAR',
  UNASSIGNED_NAME: 'Sin asignar'
}

export const STORE_RELATIONS_REASSIGN_MODAL_DESCRIPTIONS = {
  CONFLICT:
    'Selecciona el usuario principal que debe quedar asignado para esta configuración. Puedes escoger uno de los usuarios en conflicto o buscar otro.',
  UNASSIGNED:
    'Selecciona el usuario principal para esta configuración. Como no existe uno asignado, se tomará como una relación nueva.'
}

export const STORE_RELATIONS_FILTER_CONFIG = [
  {
    key: 'supplier',
    title: 'Proveedor',
    dropdownWidth: 280,
    widthClassName: 'store-relations-filter-item'
  },
  {
    key: 'buyer',
    title: 'Cadena',
    dropdownWidth: 280,
    widthClassName: 'store-relations-filter-item'
  },
  {
    key: 'client',
    title: 'Cliente',
    dropdownWidth: 390,
    widthClassName: 'store-relations-filter-item'
  },
  {
    key: 'user',
    title: 'Usuario',
    dropdownWidth: 390,
    widthClassName: 'store-relations-filter-item'
  },
  {
    key: 'status',
    title: 'Estado',
    dropdownWidth: 250,
    widthClassName: 'store-relations-filter-item'
  }
]

export const STORE_RELATIONS_FILTER_SEARCH_PLACEHOLDER =
  'Buscar relaciones por cliente, usuario, proveedor, cadena o marca'

export const STORE_RELATIONS_TABLE_COLUMNS = [
  {
    key: 'supplier',
    label: 'PROVEEDOR',
    className: 'col-w-100'
  },
  {
    key: 'buyer',
    label: 'CADENA',
    className: 'col-w-100'
  },
  {
    key: 'reference',
    label: 'REFERENCIA',
    className: 'col-w-100'
  },
  {
    key: 'client',
    label: 'CLIENTE',
    className: 'col-w-260'
  },
  {
    key: 'principalUser',
    label: 'USUARIO PRINCIPAL',
    className: 'col-w-140'
  },
  {
    key: 'brandUsers',
    label: 'USUARIOS POR MARCA',
    className: 'col-w-130'
  },
  {
    key: 'status',
    label: 'ESTADO',
    className: 'col-w-80'
  },
  {
    key: 'action',
    label: 'ACCION',
    className: 'col-w-50 text-center'
  }
]
